import { CommonButton } from 'components/common/Forms/Button';
import { useSiteStringAttributes } from 'hooks/useAttribute';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { patientURL } from 'routes/AppRoutes';
import { CHECK_IN_SUCCESS_TEXT } from 'configs/siteAndTrustAttributes';
import { MILLIS_IN_MINUTE } from 'utils/dateUtil';
import {
  FormButtonBar,
  PatientCheckInWrapperStyled,
} from './PatientCheckIn.styled';
import { PatientCheckInLayout } from './PatientCheckInLayout';

export const PatientCheckInSuccess = () => {
  const { t } = useCommonTranslation();
  const [checkinSuccessText] = useSiteStringAttributes(CHECK_IN_SUCCESS_TEXT);
  const history = useHistory();

  useEffect(() => {
    const timeout = setTimeout(
      () => history.push(patientURL),
      MILLIS_IN_MINUTE,
    );
    return () => clearTimeout(timeout);
  }, [history]);

  return (
    <PatientCheckInLayout
      description={{ html: checkinSuccessText || t('self-checkin-success') }}
    >
      <PatientCheckInWrapperStyled>
        <FormButtonBar>
          <CommonButton
            variant="primary"
            size="large"
            onClick={() => history.push(patientURL)}
          >
            {t('ok')}
          </CommonButton>
        </FormButtonBar>
      </PatientCheckInWrapperStyled>
    </PatientCheckInLayout>
  );
};
